import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom'
import moment from 'moment'
import {Helmet} from "react-helmet";
import {ABUSE, COMMENT_MAX_CHARACTER, ELECTION_NEWS_LOADED, ELECTION_PAGE_LOAD} from '../../constants/actionTypes';
import PostAvatar from '../Post/PostAvatar'
import PrivacyModal from '../Utils/PrivacyModal'
import {
    addElectionComments,
    fetchElectionCandidates,
    fetchElectionCommentList,
    fetchRelatedElections
} from '../../actions/election';
import {getLabel} from "../../language";
import ElectionVoteModal from "./ElectionVoteModal";
import SharePostModal from "../Party/SharePostModal";
import agent from "../../agent";
import UserModal from "../AuthModal";
import {Modal} from "react-bootstrap";
import VoterLocationsTab from "../Settings/VoterLocationsTab";
import CandidateVoteDetails from "./CandidateVoteDetails";
import defaultAvatar from "../../images/avatar.svg";
import Slider from "react-rangeslider";
import {message, Popconfirm} from "antd";
import {fetchElectionNewsList} from "../../actions/election";

const mapStateToProps = state => ({
    currentUser: state.common.currentUser,
    userId: state.common.currentUser ? state.common.currentUser.id : null,
    candidatesList: state.electionList && state.electionList.candidatesList,
    isCandidatesLoading: state.electionList && state.electionList.isCandidatesLoading,
    commentsList: state.electionList && state.electionList.commentsList,
    isLoadingComment: state.electionList && state.electionList.isLoadingComment,
    relatedElectionList: state.electionList && state.electionList.relatedElectionList,
    userInfo: state.electionList && state.electionList.userInfo || [],
    isAuthorized: state.auth && state.auth.isAuthorized,
    mention: state.mention,
    anonymousMode: state.user.anonymousMode,
    ElectionNews: state.electionList.ElectionNews,
    newsList: state.polly.newsList,
});

const mapDispatchToProps = dispatch => ({
    fetchElectionCandidates: dispatch(fetchElectionCandidates),
    fetchElectionCommentList: dispatch(fetchElectionCommentList),
    fetchRelatedElections: dispatch(fetchRelatedElections),
    addElectionComments: dispatch(addElectionComments),
    fetchElectionNewsList: dispatch(fetchElectionNewsList),
    onLoad: payload => dispatch({
        type: ELECTION_PAGE_LOAD,
    }),
    NewsLoad: payload => dispatch({
      type: ELECTION_NEWS_LOADED,
      payload
    }),
    abuse: payload => dispatch({
        type: ABUSE,
        payload: agent.Abuse.setAbuse(payload)
    })
});

class ElectionPage extends Component {

    constructor(props) {
        super(props)
        this.state = {
            reaction: [],
            privacyModal: false,
            audienceSelectionModal: false,
            selectedAudiencesIds: [],
            selectedAudiences: [],
            isElectionVoteModalOpen: false,
            isAuthModalOpen: false,
            showShare: false,
            isVoterLocationModal: false,
            ability: 0,
            vision: 0,
            electionComment: "",
            electionDetails: null,
            viewMyVotes: 2,
            voterLocation: '',
            onHover: false,
            isOpenDetails: false,
            isLoading: true,
            isLoadingComment: true,
            AllCandidatesVoteList: [],
            commentCount: 0,
            voteSuccess: true,
            isAllComment: true,
            showCommentErrorMessage: true,
            max_chars: COMMENT_MAX_CHARACTER,
            chars_left: 0,
            isElectionNewsList: false
        }
    }

    componentWillReceiveProps(nextProps) {
        const {isLoadingComment, isCandidatesLoading, commentsList} = nextProps;
        const {isComment, isAllComment} = this.state
        this.setState({
            reaction: []
        })
        if (this.props.commentsList) {
            ((this.props.commentsList.length && this.props.commentsList) || []).map((item) => {
                item.abuse.myAbuse.map((items) => {
                    this.setState(prevState => ({
                        reaction: [
                            ...prevState.reaction,
                            {id: item.id, name: items.abuseType}
                        ]
                    }))
                })
            })
        }
        if ((typeof isCandidatesLoading === "boolean") && !isCandidatesLoading) {
            this.setState({
                isLoading: false
            })
        }
        if ((typeof isLoadingComment === "boolean") && !isLoadingComment) {
            this.setState({
                isLoadingComment: false
            })
        }
        const data = Array.isArray(commentsList) && commentsList.filter(item => item.body === isComment)
        if (data && data.length) {
            this.getAllVoteDetails()
        } else if (Array.isArray(commentsList) && commentsList != "undefined" && isAllComment) {
            this.getAllVoteDetails()
        }

      if (this.props.isAuthorized && !this.state.isElectionNewsList){
        this.setState({
          isElectionNewsList: true
        })
        this.props.fetchElectionNewsList(this.props.election.urlSlug.replace(/_/g, "%20"),this.props.election.typePage,this.props.election.electionID)
      }

        const staticDescriptionElement = document.getElementById('main-description');

      if (staticDescriptionElement) {
        if (this.props.election.seoDescription) {
          staticDescriptionElement.remove();
        }
      }
    }

    componentWillUnmount() {
      const newStaticDescriptionElement = document.createElement('meta');
      newStaticDescriptionElement.id = 'main-description';
      newStaticDescriptionElement.name = 'description';
      newStaticDescriptionElement.content = 'A new social platform dedicated to politics. We\'re taking the good ingredients from the current set of social networks and adding a few new ones to make a unique experience. We\'re just getting started so this is just the beginning.';
      document.head.appendChild(newStaticDescriptionElement);
    }

    componentWillMount() {
        this.props.onLoad()
        const {currentUser, election} = this.props;
        if (currentUser) {
            this.setState({
                viewMyPostsAndComments: currentUser ? currentUser.viewMyPostsAndComments : null,
                replyMyPostsAndComments: currentUser ? currentUser.replyMyPostsAndComments : null,
                viewMyVotes: currentUser ? (currentUser.viewMyVotes && parseInt(currentUser.viewMyVotes) === 1) ? 2 : currentUser.viewMyVotes : null,
                viewMyPostsAndCommentsDefault: currentUser ? currentUser.viewMyPostsAndComments : null
            })
        }
        if (election) {
            this.props.fetchElectionCandidates(election.electionID)
            this.props.fetchElectionCommentList(election.electionID)
            this.props.fetchRelatedElections(election.electionID)
        }
        this.getLocation()
        this.getAllVoteDetails()
    }

    async componentDidMount() {
        this.setState({
            reaction: []
        })
      if (this.props.commentsList) {
            this.props.commentsList.map((item) => {
                item.abuse.myAbuse.map((items) => {
                    this.setState(prevState => ({
                        reaction: [
                            ...prevState.reaction,
                            {id: item.id, name: items.abuseType}
                        ]
                    }))
                })
            })
        }
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if ((prevProps !== this.props) && this.props?.commentsList) {
            const currentCommentDetail = await ((this.props?.commentsList?.length && this.props?.commentsList) || [])?.find((ele) => ele?.id === this.props?.commentId);
            if (!!currentCommentDetail) {
                const elements = document.querySelector(`[data-id="${this.props?.commentId}"]`);
                const y = elements?.getBoundingClientRect()?.top + window.pageYOffset;
                if (elements) {
                    window.scrollTo({behavior: "smooth", top: y - 100})
                }
            } else {
                if (this.state.showCommentErrorMessage && this.props?.commentId) {
                    setTimeout(() => {
                        message.error(getLabel(335));
                    }, 1000);
                }
                this.setState({
                    ...this.state,
                    showCommentErrorMessage: false
                });
            }
        }
    }

    getAllVoteDetails = () => {
        const {election, commentsList} = this.props;
        try {
            agent.Elections.getCandidatesAllVoteDetails(election && election.electionID).then(res => {
                if (res) {
                    let filterComment = []
                    res.map(item => {
                        filterComment.push(item)
                    });
                    let finalComment = [...filterComment, ...(commentsList || [])]
                    finalComment.sort(function (a, b) {
                        return new Date(b.dateCreated) - new Date(a.dateCreated);
                    });
                    this.setState({
                        AllCandidatesVoteList: finalComment,
                        commentCount: commentsList && commentsList.length || 0,
                        isAllComment: false
                    })
                }
            }, err => {
                console.log(err.message);
            })
        } catch (e) {
            console.log(e);
        }
    }

    getLocation = () => {
        agent.UserLocations.get().then(res => {
            if (res && res.length) {
                this.setState({
                    voterLocation: res[0] && res[0].id,
                })
            }
        })
    }

    onChange = (e) => {
        if (e.target.name === 'viewMyVotes') {
            const state = this.state;
            state[e.target.name] = parseInt(e.target.value);
            this.setState({state})
        }else if(e.target.name === 'commentBody'){
            const text = e.target.value;
            const textLength = text.length;
            if(textLength <=  COMMENT_MAX_CHARACTER){
                this.setState({
                    [e.target.name]: e.target.value,

                });
                this.setState(({
                    chars_left: textLength
                }))
            }

        }else {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }

    handleOnSlider = (e, field) => {
        this.setState({[field]: e});
    }

    privacyModal = () => {
        this.setState({
            privacyModal: !this.state.privacyModal,
        })
    }

    onSubmit = () => {
        const {currentUser, election} = this.props;
        const commentAdd = {
            "id": "",
            "electionID": election && election.electionID || '',
            "body": "",
            "viewMyPostsAndComments": this.state.viewMyPostsAndComments || 0,
            "viewMyVotes": this.state.viewMyVotes || 0,
            "replyMyPostsAndComments": this.state.replyMyPostsAndComments || 0,
            "viewMyPostsAndCommentsDefault": currentUser ? currentUser.viewMyPostsAndComments : null,
            "replyMyPostsAndCommentsDefault": currentUser ? currentUser.replyMyPostsAndComments : null,
            "Anonymous": JSON.parse(localStorage.getItem("AnonymousMode"))
        }
        if (this.state.commentBody) {
            commentAdd.body = this.state.commentBody;
            this.props.addElectionComments(election.electionID, commentAdd);
        }

        this.setState({
            commentBody: '',
            chars_left: 0,
            isComment: this.state.commentBody
        })
    }

    audienceSelectionModal = () => {
        this.setState({
            privacyModal: true,
        })
    }

    isElectionVoteModel = (item) => {
        const {currentUser} = this.props;
        const {isElectionVoteModalOpen, voterLocation} = this.state;
        if (!(currentUser && currentUser.email)) {
            this.setState({
                isAuthModalOpen: true
            })
        } else if (!voterLocation) {
            this.setState({
                isVoterLocationModal: true,
            })
        } else {
            this.setState({
                isElectionVoteModalOpen: !isElectionVoteModalOpen,
                electionDetails: !isElectionVoteModalOpen ? item : null,
                ability: 0, vision: 0,
                electionComment: "",
                viewMyVotes: null,
            })
        }
    };

    isElectionVoteSubmit = () => {
        const {electionDetails, vision, ability, electionComment, viewMyVotes} = this.state
        const {election, currentUser} = this.props;
        let vote = {
            personID: (electionDetails && electionDetails.electionType) === "person" ? (electionDetails && electionDetails.personID) : null,
            partyId: electionDetails && electionDetails.partyID,
            electionID: election && election.electionID,
            vision: vision,
            ability: ability,
            comment: electionComment,
            isUndecided: ((electionDetails && electionDetails.partyID) || (electionDetails && electionDetails.personID)) ? false : true,
            viewMyVotes: viewMyVotes,
            viewMyVotesDefault: (currentUser && currentUser.viewMyVotes)
        };
        agent.Elections.postCandidatesVote(vote, (election && election.electionID)).then(res => {
            if (res) {
                this.props.fetchElectionCandidates(election && election.electionID)
                this.getAllVoteDetails()
                this.setState({
                    showShare: vote.partyId ? true : false,
                    isElectionVoteModalOpen: false,
                    ability: 0, vision: 0,
                    electionComment: "",
                    viewMyVotes: null,
                })
            }
        }, err => {
            console.log(err.message)
        })
    };

    voterLocationAdded = () => {
        this.setState({
            isVoterLocationModal: false,
            voterLocation: true
        })
    }

    handleDeleteElectionComment = async (id) => {
        let formData = new FormData();
        let data = {}
        data.EntityId = id
        data.EntityType = "ElectionComment"
        for (const key in data) {
            formData.append(key, data[key]);
        }
        await agent.DeleteComment.deleteComment(formData).then(res => {
            this.props.fetchElectionCommentList(this.props.election.electionID)
            if (res.statusCode === 200) {
                const newCandidatesVoteList = this.state.AllCandidatesVoteList.filter(i => i.id !== id)
                this.setState({
                    AllCandidatesVoteList: newCandidatesVoteList
                })
            }
        }).catch(err => console.log('Oh no!', err));
    }

    handleReaction = (name, id, authorID) => {
        const data = this.state.reaction.filter(item => item.id === id && item.name === name)
        if (!data.length) {
            this.setState(prevState => ({
                reaction: [
                    ...prevState.reaction,
                    {id, name}
                ]
            }))
        }
        this.props.abuse({
            "EntityId": id,
            "EntityType": "ElectionComment",
            "AbuseType": name,
            "AuthorId": authorID,
        });
    };

    handleReportAbuse = () =>{
        message.error(getLabel(338));
    }

    parseBody = body => {
      var matchedMentions = body.match(/\[~(.*?)\]/g);
      let content = body;
      if (matchedMentions && matchedMentions.length > 0) {
        matchedMentions.map(res => {
          const userName = res.match(/\[~(.*?)\]/).pop();
          const displayName = this.getDisplayNameFromMentions(userName);
          content = content.replace(res, `<a href=/@${userName}>${displayName}</a>`);
        })
      }
      return {__html: content};
    }

    render() {
        const {electionDate, isPrimary, officeProvinceCode, officeCountryName, officeName, officeProvinceName, seoDescription, seoKeywords, seoTitle, termTitle, description} = this.props.election;
        const {candidatesList, commentsList, userInfo, relatedElectionList, anonymousMode, ElectionNews} = this.props;
        const mayReportAbuse = this.props?.currentUser?.user_privilege?.mayReportAbuse
        const {
            privacyModal, isElectionVoteModalOpen, vision, ability, electionComment, showShare, electionDetails, viewMyVotes,
            isAuthModalOpen, isLoading, isLoadingComment, AllCandidatesVoteList, reaction
        } = this.state;
        return (

            <div>
                <div className={`polly-container ${anonymousMode ? "cw" : ""}`}>
                    {isAuthModalOpen && <UserModal isAuthModalOpen={isAuthModalOpen}
                                                   onCloseAuthModal={() => this.setState({isAuthModalOpen: false})}/>}
                    {
                        isElectionVoteModalOpen &&
                        <ElectionVoteModal
                            isElectionVoteModalOpen={isElectionVoteModalOpen}
                            ability={ability}
                            vision={vision}
                            electionComment={electionComment}
                            displayName={(electionDetails && electionDetails.displayName) ? electionDetails.displayName : (electionDetails && electionDetails.partyName)}
                            viewMyVotes={viewMyVotes || 2}
                            isElectionVoteModel={this.isElectionVoteModel}
                            isElectionVoteSubmit={this.isElectionVoteSubmit}
                            handleOnSlider={this.handleOnSlider}
                            onChange={this.onChange}
                        />
                    }
                    {
                        showShare && electionDetails && !this.props.anonymousMode && <SharePostModal
                            electionVoteDetails={electionDetails || []}
                            showShare={showShare}
                            onCloseShare={() => this.setState({showShare: false})}/>
                    }
                    {
                        privacyModal &&
                        <PrivacyModal
                            onChange={this.onChange}
                            privacyModal={this.privacyModal}
                            viewMyVotes={true}
                            selectedAudience={true}
                            isPoliticianQuestion={true}
                            state={this.state}
                        />
                    }
                    {this.state.isVoterLocationModal &&
                    <Modal show={this.state.isVoterLocationModal}
                           bsSize="large"
                           className="polly-modal"
                           aria-labelledby="contained-modal-title-lg"
                           onHide={() => this.setState({isVoterLocationModal: false})}>
                        <div id="votepopup">
                            <div className="modal-header">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>{getLabel(214)}</h3>
                                    </div>
                                </div>
                                <button type="button"
                                        className="close"
                                        onClick={() => this.setState({isVoterLocationModal: false})}
                                        data-dismiss="modal"
                                        aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <VoterLocationsTab {...this.props}
                                                           onVoterLocationAdded={this.voterLocationAdded}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>}
                    <div className="container">
                        <Helmet>
                            <link rel="canonical" href={`${new URL(document.URL).origin}/${this.props?.election?.urlSlug}`}/>
                            <title>{seoTitle}</title>
                            <meta name="keywords" content={seoKeywords}/>
                            <meta name="robots" content="index,follow"/>
                            <meta name="description" content={seoDescription}/>
                            <meta name="termTitle" content={termTitle && termTitle}/>
                            <meta name="officeName" content={officeName && officeName}/>
                        </Helmet>
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <div className="row">
                                    <div className="col-md-4" style={{Height: 155}}>
                                        <a className="square" style={{height: '100%'}}>
                                            <i className="fa fa-clock-o text-white"/>
                                            <span className="date" style={{marginTop:'10px'}}>
                                            {electionDate && moment(new Date(electionDate)).format('dddd, MMMM Do YYYY')}
                                                <span className="superscript"/>
                                        </span>
                                            <span className="explanation">{termTitle}</span>
                                        </a>
                                    </div>
                                    <div className="col-md-8">
                                        <div className="politicians-text-card">
                                            <h1 className={`${anonymousMode ? "cw" : ""}`}>{seoTitle}</h1>
                                            <span className="occupation">{officeName}</span>
                                            <span
                                                className="description"> {officeProvinceName ? officeProvinceName + ', ' : ''}
                                                {officeCountryName ? officeCountryName + ': ' : ''}</span>
                                            <span>{description}</span>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <h6 className="bio">{seoDescription}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row subfooter">
                            <div className="col-md-8 ">
                                <div className={`politiqbox${anonymousMode ? "-dark cw" : ""}`}>
                                    <h4 className={`${anonymousMode ? "cw" : ""}`}>{getLabel(133)}</h4>
                                    <ul className="primary-politicians election-voted" id="primary-politicians">
                                        {isLoading && <p className="loading-spinner">&nbsp;</p>}
                                        {
                                            (candidatesList || []).map((item, i) => {
                                                return <CandidateVoteDetails
                                                    {...item}
                                                    index={i}
                                                    history={this.props.history}
                                                    key={i}
                                                    election={this.props.election}
                                                    userInfo={userInfo}
                                                    anonymous={anonymousMode}
                                                    isElectionVoteModel={this.isElectionVoteModel}
                                                />
                                            })
                                        }
                                        {!(candidatesList && candidatesList.length) && !isLoading &&
                                        <div>Not found any candidate</div>}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className={`politiqbox${anonymousMode ? "-dark cw" : ""}`}>
                                    <h3 className={`${anonymousMode ? "cw" : ""}`}>{getLabel(249)}</h3>
                                    <fieldset className="form-group m-t-5 m-b-50">
                                        {commentsList && commentsList.length === 0 &&
                                        <label className={`${anonymousMode ? "cw" : ""}`}
                                               style={{fontWeight: "unset"}}>{getLabel(119)}</label>}
                                        <textarea
                                            className={`form-control${anonymousMode ? "-dark cw" : ""} form-control-lg`}
                                            rows="8"
                                            name="commentBody"
                                            placeholder={getLabel(59)}
                                            value={this.state.commentBody || ''}
                                            onChange={this.onChange}
                                        />
                                        <div className='election-page-comment-range'>{this.state.chars_left}/{this.state.max_chars}</div>
                                        <hr/>
                                        {this.props.isAuthorized &&
                                        <div className="float-right">
                                            <a onClick={() => this.privacyModal()}
                                               className="small privacylink m-r-20" data-toggle="modal"
                                               data-target="#privacysettings">
                                                <i className="mdi mdi-glasses"/>{getLabel(105)}
                                            </a>
                                            <button disabled={!this.state.commentBody}
                                                    className="btn btn-lg btn-primary float-right"
                                                    onClick={this.onSubmit}>{getLabel(106)}</button>
                                        </div>
                                        }
                                        {
                                            !this.props.isAuthorized && <div style={{textAlign: 'right'}}><Link
                                                to={'/register'}>{getLabel(11)}</Link>{getLabel(120)}</div>
                                        }
                                    </fieldset>
                                    <div className="comments" style={{maxHeight: 1030}} id="election-cmt-scr">
                                        {isLoadingComment && <p className="loading-spinner">&nbsp;</p>}
                                        {
                                            (AllCandidatesVoteList || []).map((item, i) => {
                                                return (
                                                    <div className="comment" key={i} data-id={item.id}>
                                                        <header>
                                                            <div className="facebook-reaction col-md-2 fr">
                                        {mayReportAbuse ? <span className="like-btn">
                                            <span
                                                className="like-btn-text">Abuse?</span>
                                                <ul className={`${this.props.anonymousMode ? "reactions-box-dark" : "reactions-box"}`}>
                                                    <span className="reaction reaction-vulgar" onClick={() => {
                                                        this.handleReaction("Vulgar", item.id, item.author.id)
                                                    }} data-reaction="Vulgar"/>
                                                    <span className="reaction reaction-irrelevant" onClick={() => {
                                                        this.handleReaction("Irrelevant", item.id, item.author.id)
                                                    }} data-reaction="Irrelevant"/>
                                                    <span className="reaction reaction-pointless" onClick={() => {
                                                        this.handleReaction("Pointless", item.id, item.author.id)
                                                    }} data-reaction="Pointless"/>
                                                </ul>
                                            </span> : <span className="like-btn-text" onClick={()=>this.handleReportAbuse()}>Abuse?</span>}
                                                                <div className="like-stat">
                                                                <span
                                                                    className="like-emo">{reaction && reaction.map((items) => (items.id === item.id ?
                                                                    <span
                                                                        className={`like-btn-${items.name || ""}`}/> : ""))}</span>
                                                                    <span className="like-details">you</span>
                                                                </div>
                                                                <div className="delete-comment">
                                                                    {item.id && this.props?.currentUser?.roles[0] === "Admin" &&
                                                                    <div style={{
                                                                        marginLeft: 70,
                                                                        clear: 'both',
                                                                        whiteSpace: 'nowrap'
                                                                    }}>
                                                                        <Popconfirm placement="bottomLeft"
                                                                                    title={getLabel(310)}
                                                                                    onConfirm={() => this.handleDeleteElectionComment(item.id)}
                                                                                    okText="Yes" cancelText="No">
                                                                            <div style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                color: "#43c5e6"
                                                                            }}>
                                                                                <i className="fa fa-trash"/>
                                                                            </div>
                                                                        </Popconfirm>
                                                                    </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="authorimage">{
                                                                item.author ? (userInfo &&
                                                                    <a>
                                                                        <PostAvatar
                                                                            userName={userInfo[item.authorId] && userInfo[item.authorId].userName || ''}
                                                                            isAnonymous={item.anonymous}/>
                                                                        <span
                                                                            className={`${parseInt((userInfo[item.authorId] || {}).gender) === 1 && "female "}${parseInt((userInfo[item.authorId] || {}).gender) === 2 && "male"}`}/>
                                                                    </a>) : (userInfo && userInfo[item.user && item.user.id] ?
                                                                    <a>
                                                                        <PostAvatar
                                                                            userName={userInfo[item.user && item.user.id] && userInfo[item.user.id].userName || ''}
                                                                            isAnonymous={item.anonymous}/>
                                                                        <span
                                                                            className={`${parseInt((userInfo[item.user && item.user.id] || {}).gender) === 1 && "gender female "}${parseInt((userInfo[item.user && item.user.id] || {}).gender) === 2 && " gender male"}`}/>
                                                                    </a> :
                                                                    <img onError={e => e.target.src = defaultAvatar}
                                                                         src={(item.person && item.person.photoName) ? `/images/people/${item.person && item.person.personID}/official/${item.person && item.person.photoName}` : defaultAvatar}
                                                                         alt="" width="50" height="50"
                                                                         className="img-circle"/>)
                                                            }
                                                            </div>
                                                            <div className="articletitle">
                                                                <div className="author">{
                                                                    item.author ?
                                                                        <div className="author">
                                                                            {userInfo && userInfo[item.authorId] &&
                                                                            (item.anonymous ?
                                                                                <Link to="">{getLabel(284)}</Link> :
                                                                                <Link
                                                                                    to={`/@${userInfo[item.authorId].userName}`}>
                                                                                    {userInfo[item.authorId].displayName}, {userInfo[item.authorId].displayLocation}
                                                                                </Link>)}
                                                                        </div> :
                                                                        (userInfo && userInfo[item.user && item.user.id] ?

                                                                            (item.anonymous ?
                                                                                <Link to="">{getLabel(284)}</Link> :
                                                                                <Link
                                                                                    to={`/@${userInfo[item.user && item.user.id].userName}`}>
                                                                                    {userInfo[item.user && item.user.id].displayName},
                                                                                    {userInfo[item.user && item.user.id].displayLocation}
                                                                                </Link>) : (item.anonymous ?
                                                                                <Link to="">{getLabel(284)}</Link> :
                                                                                <a>{item.user && item.user.displayName}, {item.user && item.user.displayLocation}</a>))
                                                                }
                                                                </div>
                                                                <div className="date">
                                                                    {item.dateCreated && new Date(item.dateCreated).toDateString() + " " + new Date(item.dateCreated).toLocaleTimeString('en-US')}
                                                                </div>
                                                                {
                                                                    item.person && item.person.displayName &&
                                                                    <div className="small">voted for
                                                                        <a href={`/${item.person && item.person.urlSlug}`}> {item.person && item.person.displayName}</a>
                                                                    </div>
                                                                }
                                                                <div className="m-t-15">
                                                                    {
                                                                        item.vision > 0 &&
                                                                        <div className="row">
                                                                            <div className="col-md-3 vote-col-name">
                                                                                <span>{getLabel(111)}({item.vision})</span>
                                                                            </div>
                                                                            <div className="col-md-9">
                                                                                <Slider min={0} max={10}
                                                                                        value={item.vision}
                                                                                        orientation="horizontal"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    }

                                                                    {
                                                                        item.ability > 0 &&
                                                                        <div className="row">
                                                                            <div className="col-md-3 vote-col-name">
                                                                                <span>{getLabel(110)}({item.ability})</span>
                                                                            </div>
                                                                            <div className="col-md-9">
                                                                                <Slider min={0} max={10}
                                                                                        value={item.ability}
                                                                                        orientation="horizontal"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className="comment-body">
                                                                    <div className="textcomment">
                                                                        {item.comment ? item.comment : item.body}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </header>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row subfooter m-t-20">
                            <div className="col-md-6">
                                <div className={`politiqbox${anonymousMode ? "-dark cw" : ""}`}>
                                    <h3 className={`${anonymousMode ? "cw" : ""}`}>{getLabel(121)}</h3>
                                    {ElectionNews?.length ? ElectionNews.map((item,i)=>{
                                        return <div key={i} className="comment pointer">
                                          <Link to={`/posts/${item.slug}`}>
                                            <header>
                                              <div className="authorimage"><a href="#">{item && <PostAvatar
                                                userName={item.authorUserName || item.author && item.author.userName || ''}/>}</a>
                                              </div>
                                              <div className="articletitle">
                                                <div className="text">
                                                  <a style={{color: '#000000', fontWeight: 'lighter'}}>
                                                    <div style={{fontSize: 13}}
                                                         dangerouslySetInnerHTML={this.parseBody(item.body)}/>
                                                  </a>
                                                </div>
                                              </div>
                                            </header>
                                          </Link>
                                          <div className="date hidden">{getLabel(122)}</div>
                                        </div>
                                      })
                                        :
                                      <div className="comments inthenews">
                                        <div>{getLabel(123)}</div>
                                      </div>
                                    }
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className={`politiqbox${anonymousMode ? "-dark cw" : ""}`}>
                                    <h3 className={`${anonymousMode ? "cw" : ""}`}>{getLabel(135)}</h3>
                                    <ul>
                                        {
                                            ((relatedElectionList?.length && relatedElectionList) || [])?.map((item, i) => {
                                                return (
                                                    <li key={i}>
                                                        <div style={{height: 155}}>
                                                            <a className="square" href={`/${item.urlSlug}`}>
                                                                <i className="fa fa-clock-o text-white"/>
                                                                <span
                                                                    className="date">{item.electionDate && moment(new Date(item.electionDate)).format('dddd, MMMM Do YYYY')}<span
                                                                    className="superscript"/></span>
                                                                <span className="explanation">{item.description}</span>
                                                            </a>
                                                        </div>
                                                    </li>
                                                );
                                            })
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ElectionPage.propTypes = {
    election: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(ElectionPage);
